import React, { useState } from 'react';
import axios from 'axios';
import { Container, TextField, Button, Typography, Snackbar } from '@mui/material';
import { Alert } from '@mui/material';  // Import the Alert component
import logo from '../data/logo192.png'; // Adjust the path as necessary
import { useNavigate } from 'react-router-dom';


const ForgotPassword = ({ onCancel }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);   // State to control Snackbar visibility
  const [snackbarType, setSnackbarType] = useState('error'); // Type of the Snackbar ('success' or 'error')
  

  const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'var(--black1)', // Focus border color
      },
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: 'var(--black1)', // Focus label color
    },
  };
  const buttonStyles = {
    backgroundColor: 'var(--black1)',
    color: 'var(--yellow1)',
    '&:focus': {
      backgroundColor: 'var(--black1)', // Ensuring the focus color remains the same
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://stdiscount.bond/api/auth/forgot-password', {
        email: email,
      });

      if (response.status === 200) {
        setSnackbarType('success');
        setSnackbarOpen(true);
        setTimeout(onCancel, 1500);

      }
    } catch (err) {
      setSnackbarType('error');
      setSnackbarOpen(true);
      setErrorMessage("Greška pri slanju. Provjerite e-mail"); 
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container 
      component="main" 
      maxWidth="xs" 
      className="flex flex-col items-center justify-center min-h-screen"
    >
      <div className='mt-[-40%] sm:mt-[-25%] md:sm:mt-[-20%]'>
        <div className="my-10 flex flex-col items-center">
        <img src={logo} alt="Logo" className="h-14 w-14 mb-2" />
        <span         className="text-gray-700 bg-gray-100 p-2 px-4  text-xl font-semibold" >STdiscount</span>
        </div>
        <div className="p-8 flex flex-col items-center bg-white shadow-lg rounded-md">
          
          <Typography component="h1" variant="h5" className="mb-4">
            Zaboravljena lozinka
          </Typography>
          <form className="w-full mt-2" onSubmit={handleSubmit} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              className="mb-4"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx = {textFieldStyles}
            />

            {/* Display error message */}
            {errorMessage && <Typography variant="body2" color="error">{errorMessage}</Typography>}
            <Button
                fullWidth
                variant="outlined"
                color="primary"
                className="mt-4"
                onClick={onCancel}
                sx = {{
                  borderColor: 'var(--black1)',
                  color: 'var(--black1)',
                }}
             >
                Back to login
            </Button>
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className="mt-8 mb-4"
              sx = {buttonStyles}
            >
              Reset password
            </Button>
          </form>
        </div>
      </div>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarType} variant="filled">
          {snackbarType === 'success' ? 'Poslan je aktivacijski link korisniku' : errorMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ForgotPassword;
